<div class="col-12">
    <div class="faq">
        <div class="faq__header">
            <div class="row" style="margin-right:0;">
                <div class="col-12 text-center">
                    <h1>Partners Portal FAQs</h1>
                </div>
            </div>
        </div>
        <div class="faq__body">
            <div class="faq__cont">
                <div class="faq__container">
                    <div class="row">
                        <div class="col-12 col-md-3">
                            <div class="faq__nav" scrollNav>
                                <ng-container *ngFor="let titleList of faqList; let i = index">
                                    <div (click)="scroll(i)" class="row">
                                        <div class="col-8">
                                            <p [ngClass] = 'titleList.active? "active" : ""'>{{titleList.title}}</p>
                                        </div>
                                        <div class="col-4">
                                            <atram-button remove-component-tag
                                                            buttonType="link"
                                                            title="navigate"
                                                            componentClass="btn-ico"
                                                            icon="atram-ico before ico-arrow-nav ico-3x ico-active">
                                            </atram-button>
                                        </div>
                                    </div>
                                    <hr *ngIf="i !== faqList.length-1" />
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-12 col-md-9">
                            <div class="faq__items">
                                <ng-container *ngFor="let list of faqList; let i = index">
                                    <h2 [id]="i" [ngClass] = 'list.active? "active" : ""'>{{list.title}}</h2>
                                    <div class="box col-12">
                                        <div class="box__cont">
                                            <ng-container *ngFor="let item of list.content; let x = index">
                                                <div class="box__contents" [ngClass]= 'item.active? "active" : ""'>
                                                    <div (click)="openQuestion(i,x)">
                                                        <div class="row">
                                                            <div class="col-11">
                                                                <h3>{{item.question}}</h3>
                                                            </div>
                                                            <div class="col-1">
                                                                <span [ngClass]= 'item.active? "ico-x" : "ico-plus"' class="atram-ico before ico-2x ico-active atram-ico--faq"></span>
                                                            </div>
                                                        </div>
                                                        <p>{{item.answer}}</p>
                                                    </div>
                                                    <hr *ngIf='x != list.content.length-1'/>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>